module.exports = __webpack_public_path__ + "img/authentication.9a3639f.svg";